import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  EyeDropperIcon, UserCircleIcon, UserIcon, PaintBrushIcon,
  RectangleStackIcon, ShieldCheckIcon, ChatBubbleBottomCenterIcon,
  ChatBubbleOvalLeftEllipsisIcon, AcademicCapIcon, PaperClipIcon,
  CurrencyRupeeIcon, BeakerIcon, QuestionMarkCircleIcon, DocumentCheckIcon,
  InboxArrowDownIcon, ArrowDownOnSquareIcon, ClockIcon, DocumentTextIcon, FolderIcon, GlobeAltIcon,
} from '@heroicons/react/16/solid';
import '../styles/scrollbar/Scrollbar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation(); // Get the current route path

  const menuItems = [
    { to: '/', label: 'Dashboard', icon: <DocumentCheckIcon /> },
    { to: '/analytics', label: 'Analytics', icon: <EyeDropperIcon /> },
    { to: '/users', label: 'Artists', icon: <UserCircleIcon /> },
    { to: '/artist-of-the-month', label: 'Artist Of The Month', icon: <AcademicCapIcon /> },
    { to: '/artist-interviews', label: 'Artist Interviews', icon: <ShieldCheckIcon /> },
    { to: '/organizations', label: 'Organizations', icon: <UserIcon /> },
    { to: '/open-calls', label: 'Open Calls', icon: <PaintBrushIcon /> },
    { to: '/reviews', label: 'Reviews', icon: <RectangleStackIcon /> },
    { to: '/subscribers', label: 'Subscribers', icon: <ShieldCheckIcon /> },
    { to: '/contact-form-submissions', label: 'All Contact Submissions', icon: <ChatBubbleOvalLeftEllipsisIcon /> },
    { to: '/contact-us-submissions', label: 'Contact Us Submissions', icon: <ChatBubbleBottomCenterIcon /> },
    { to: '/plans', label: 'Plans', icon: <AcademicCapIcon /> },
    { to: '/coupons', label: 'Coupons', icon: <PaperClipIcon /> },
    { to: '/payments', label: 'Payments', icon: <CurrencyRupeeIcon /> },
    { to: "/country-payment-gateways", label: "Country Payment Gateways", icon: <GlobeAltIcon />,},
    { to: '/users-plans', label: 'Users Plans', icon: <BeakerIcon /> },
    { to: '/log-entries', label: 'Logs', icon: <QuestionMarkCircleIcon /> },
    { to: '/invoice-generator', label: 'Invoice Generator', icon: <EyeDropperIcon /> },
    { to: '/all-invoices', label: 'Invoices', icon: <ArrowDownOnSquareIcon /> },
    { to: '/iplookup', label: 'Ip Lookup', icon: <ArrowDownOnSquareIcon /> },
    { to: '/scraper', label: 'Scraper', icon: <ArrowDownOnSquareIcon /> },
    { to: '/scraper-categories',  label: 'Scraper Categories', icon: <FolderIcon /> },
    { to: '/campaign-analytics', label: 'Campaign Analytics', icon: <BeakerIcon /> },
    { to: '/user-email-marketing', label: 'User Email Marketing', icon: <InboxArrowDownIcon /> },
    { to: '/background-task-logs', label: 'Background Task Logs', icon: <QuestionMarkCircleIcon /> },
    { to: '/email-events', label: 'Email Logs', icon: <InboxArrowDownIcon /> },
    { to: 'cron-manager', label: 'Cron Manager', icon: <ClockIcon /> },
    { to: "/admin/cron-templates/featured", label: "Cron Templates", icon: <DocumentTextIcon className="h-5 w-5" /> },
    { to: '/api-logs', label: 'API Logs', icon: <QuestionMarkCircleIcon /> },


  ];

  return (
    <aside
      className={`bg-gray-900 text-white fixed inset-y-0 left-0 z-30 transform transition-all duration-300 flex flex-col ${isOpen ? 'w-64' : 'w-16'}`}
    >
      <button
        className={`${isOpen ? 'w-full' : 'w-16'} bg-red-900 block text-white focus:outline-none p-2 h-10 transition-all duration-300`}
        onClick={toggleSidebar}
      >
        {isOpen ? '✕' : '☰'}
      </button>
      <div className="flex-grow overflow-y-auto custom-scrollbar">
        <ul className="mt-1">
          {menuItems.map((item) => (
            <li key={item.to} className="mb-2">
              <Link
                to={item.to}
                className={`flex items-center space-x-2 px-3 py-2 text-sm hover:bg-gray-700 ${location.pathname === item.to ? 'bg-gray-700' : ''
                  }`}
              >
                <span className="w-6 mr-2 text-xl">{item.icon}</span>
                <span className={`${isOpen ? 'block' : 'hidden'} ml-2`}>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;